var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { ChevronDownIcon } from "@navikt/aksel-icons";
import { useRenameCSS } from "../theme/Theme.js";
import { BodyShort, Detail } from "../typography/index.js";
import InternalHeaderButton from "./InternalHeaderButton.js";
export const InternalHeaderUserButton = forwardRef((_a, ref) => {
    var { as, name, description, className } = _a, rest = __rest(_a, ["as", "name", "description", "className"]);
    const { cn } = useRenameCSS();
    return (React.createElement(InternalHeaderButton, Object.assign({}, rest, { as: as, ref: ref, className: cn("navds-internalheader__user-button", className) }),
        React.createElement("div", null,
            React.createElement(BodyShort, { size: "small", as: "div" }, name),
            description && React.createElement(Detail, { as: "div" }, description)),
        React.createElement(ChevronDownIcon, { "aria-hidden": true })));
});
export default InternalHeaderUserButton;
//# sourceMappingURL=InternalHeaderUserButton.js.map